import { getDateTime } from './getDateTime'
import { parseToDate } from './parseToDate'
import { InputDate } from './types/inputDate'

export const getFormattedDateTime = (date?: InputDate, locale?: string, options?: Intl.DateTimeFormatOptions): string =>
  getDateTime(locale, options).format(parseToDate(date))
